import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { t } from 'utils/translates';
import _ from 'lodash';

class UserFlowFundsTypesTransactionSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleSelectAll: t('Все операции'),
      value: this.getVerifiedPropStartValue()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.props.handleChangeValue(this.state.value);
    }
  }

  getVerifiedPropStartValue = () => {
    const searchVal = this.props.userPointsTypes.find(
      i => i.id.toString() === this.props.startValue
    );
    if (searchVal) {
      return this.props.startValue;
    }
    return null;
  };

  getSelectValueTitle = () => {
    if (this.state.value === null) {
      return this.state.titleSelectAll;
    }
    return this.props.userPointsTypes.find(
      i => i.id.toString() === this.state.value
    ).title;
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    this.setState({ value: newValue });
  };

  render() {
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-default dropdown-toggle"
          data-toggle="dropdown"
          title={this.state.titleSelectAll}
          aria-expanded="false"
        >
          {this.getSelectValueTitle()}
        </button>
        <ul className="dropdown-menu" role="menu">
          <li className={this.state.value === null ? 'active' : ''}>
            <a href="" onClick={e => this.changeValue(e, null)}>
              {t('Все операции')}
            </a>
          </li>
          {this.props.userPointsTypes.map(pointsTypeItem => (
            <li
              key={`userFlowFundsTypesTransactionSelectItem${pointsTypeItem.id}`}
              className={this.state.value === pointsTypeItem.id ? 'active' : ''}
            >
              <a
                href=""
                onClick={e => this.changeValue(e, pointsTypeItem.id.toString())}
              >
                {pointsTypeItem.title}
              </a>
            </li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
}

UserFlowFundsTypesTransactionSelect.defaultProps = {
  startValue: null
};

UserFlowFundsTypesTransactionSelect.propTypes = {
  startValue: PropTypes.string,
  userPointsTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  handleChangeValue: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  userPointsTypes: _.sortBy(
    getItemFromRefList(state, 'userFlowFundsTypesTransactionNew'),
    'title'
  )
});

export default withRouter(
  connect(mapStateToProps)(UserFlowFundsTypesTransactionSelect)
);



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/UserFlowFundsHistoryTable/inputs/UserFlowFundsTypesTransactionSelect.js